import styles from './index.module.css'
import cn from 'clsx'
import React from 'react'
import { CatalogIcon } from 'components/ui/icon/svg-icons'
import InlineLink from 'components/ui/inline-link'
import Text from 'components/ui/text'
import VerticalSpacer from 'components/ui/vertical-spacer'
export const DiscoCatalogLink = ({
  catalog,
  discoverySuiteEnabled,
}: {
  catalog?: {
    name: string
    url: string
    id: number
    primary_shares: boolean
  }
  discoverySuiteEnabled: boolean
}): React.ReactNode => {
  return (
    <>
      <Text type="H300" className={styles.title}>
        DISCO Catalog
      </Text>
      <VerticalSpacer type="smaller" />
      {catalog ? (
        <>
          <div className={styles.action}>
            <Text
              type="paragraph"
              className={cn(styles.primary, {
                [styles.disabledText]: !catalog.primary_shares,
              })}
            >
              <CatalogIcon size={16} color="#344563" /> {catalog.name}
            </Text>
          </div>
          <Text
            type="paragraph"
            className={cn(styles.primaryUrl, {
              [styles.disabledText]: !catalog.primary_shares,
            })}
          >
            {catalog.url}
          </Text>
        </>
      ) : (
        <Text type="paragraph" className={styles.noPrimary}>
          <CatalogIcon size={16} color="#344563" /> No Primary Catalog Set
        </Text>
      )}
      <VerticalSpacer type="smaller" />
      {!catalog && (
        <Text type="H300" className={styles.cta}>
          {discoverySuiteEnabled ? (
            <>
              <InlineLink to="/catalogs" target="_blank">
                Set a Primary Catalog
              </InlineLink>{' '}
              to make it available on your pages and playlists.
            </>
          ) : (
            <>
              <InlineLink to="/settings/billing" target="_blank">
                Upgrade to Discovery Suite
              </InlineLink>{' '}
              to link to your Catalog on your pages and playlists.
            </>
          )}
        </Text>
      )}
      {catalog && (
        <Text type="H300" className={styles.cta}>
          {catalog.primary_shares ? (
            <InlineLink to={`/catalogs/${catalog.id}/access`} target="_blank">
              Change Primary Catalog
            </InlineLink>
          ) : (
            <>
              Sharing for this catalog is turned off.{' '}
              <InlineLink to={`/catalogs/${catalog.id}/access`} target="_blank">
                Enable catalog sharing
              </InlineLink>{' '}
              to link it to your playlist and track shares.
            </>
          )}
        </Text>
      )}
    </>
  )
}
